import { TableDataKey } from '../types/table-data-key';
import { TableFilter } from '@web/common';
import { Nillable } from '@web/utils';

export class TableRowsSelection<Item, Filter> {
  public constructor(
    public readonly isAllSelected: boolean,
    public readonly includedIds: Array<Item[TableDataKey<Item>]>,
    public readonly excludedIds: Array<Item[TableDataKey<Item>]>,
    public readonly filter: Nillable<TableFilter<Filter>>,
  ) {}
}
